import { useTranslation } from 'react-i18next'

import { FieldRow, FieldSkeleton, FieldsTable, FieldViewValue } from '@/components/layout/field-row'
import { TabCard } from '@/components/layout/tab-card'

const ROW_LABEL_KEYS = [
  'organisation:places.building.toggles.parcelPendingAvailable',
  'organisation:places.building.parcelPending.label',
  'organisation:places.other.luxer.title',
  'organisation:places.other.apartments.title',
  'organisation:places.building.saltoSpaceCache.label',
] as const

// Note: title and labels are real, only the values are skeletons
export const OtherTabSkeleton = () => {
  const { t } = useTranslation(['organisation'])

  return (
    <TabCard title={t('organisation:places.other.title')}>
      <FieldsTable aria-hidden>
        {ROW_LABEL_KEYS.map((labelKey) => (
          <FieldRow key={labelKey} label={t(labelKey)}>
            <FieldViewValue>
              <FieldSkeleton height="1.6rem" width="20rem" />
            </FieldViewValue>
          </FieldRow>
        ))}
      </FieldsTable>
    </TabCard>
  )
}
